import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{page-title \'PictureWham\'}}\n\n{{outlet}}",{ moduleName: "frontend/templates/application.hbs" })